<template>
    <section class="chart-container">
          <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="统计维度" >
					<el-select v-model="dimension" placeholder="请选择统计维度"  style="width:100px"   @change="getDataList" >
						<el-option label="项目" value="project"></el-option>
						<el-option label="点位" value="device"></el-option>
                        <el-option label="功能区" value="functionArea"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="项目">
					<el-select v-model="filters.projectId" multiple  collapse-tags  style="width:220px" filterable  @change="getDevices">
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称"   v-if="dimension!='project'">
					<el-select v-model="filters.mn" filterable  multiple  collapse-tags @change="getFactorsByMn"  style="width:220px">
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="功能区" >
					<el-select v-model="filters.functionalArea"  reserve-keyword>
                        <el-option label="全部" value=""></el-option>
						<el-option
							v-for="item in functionalAreaList"
							:label="item.name"
							:value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="因子"  >
					<el-select v-model="filters.facKeyword"   style="width:100px"  >
                        <el-option
							v-for="item in factors"
							:label="item.name"
							:value="item.key" :key="item.key">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="数据类型">
					<el-select v-model="filters.datatype"  @change="changeType"   style="width:100px" >
						<el-option label="天" value="day"></el-option>
                        <el-option label="月" value="month"></el-option>
                        <el-option label="季度" value="quarter"></el-option>
                        <el-option label="年" value="year"></el-option>
                        <el-option label="自定义" value="choose"></el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="日期"  v-if="filters.datatype!='choose'">
					<el-date-picker  v-model="filters.time" :type="timeType"  value-format="yyyy-MM-dd"  key="time">  </el-date-picker>
                </el-form-item>
                <el-form-item label="日期"  v-if="filters.datatype=='choose'">
                    <el-date-picker v-model="filters.timeRange" type="daterange"  align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"   :picker-options="pickerOptions" value-format="yyyy-MM-dd" key="timeRange"></el-date-picker>
                </el-form-item>
                <el-form-item  v-if="filters.datatype=='quarter'">
                    <el-select v-model="filters.quarter"    style="width:100px"  reserve-keyword>
                        <el-option value="1" label="第一季度"></el-option>
                        <el-option value="2" label="第二季度"></el-option>
                        <el-option value="3" label="第三季度"></el-option>
                        <el-option value="4" label="第四季度"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item>
                    <my-button  @select-type="clickBtn" QueryButtonShow ResetButtonShow ExportButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

       <el-table :data="dataList"  highlight-current-row v-loading="listLoading" border :height="formHeight">
           	<el-table-column type="index" label="排名" width="60"  > </el-table-column>
			<el-table-column  label="项目名称"   min-width="120" prop="projectName"  v-if="dimension!='functionArea'"> </el-table-column>
            <el-table-column  label="功能区名称"   min-width="120" prop="functionalAreaName"   v-if="dimension=='device'||dimension=='functionArea'"></el-table-column>
			<el-table-column label="点位名称"   min-width="120" prop="deviceName"     v-if="dimension=='device'"></el-table-column>
            <el-table-column prop="dayComplianceRate" label="昼达标率（%）"  min-width="120" sortable></el-table-column>
            <el-table-column prop="nightComplianceRate" label="夜达标率（%）"  min-width="120" sortable></el-table-column>
		</el-table>
        
    </section>
</template>

<script>
    import {getProjects,selectNoiseDataForRank,getFunctionalAreaList,getDevicesByProjectId} from '../../api/api.js';
    import {formatDateDay,in_array } from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

	export default {
        components: { myButton },
        data() {
            return {
                filters: {
                    facKeyword:'dayComplianceRate',
                    projectId:[],
                    time:"",
                    datatype:"day",
                    functionalArea:"",
                    quarter:"1",
                    timeRange:[],
                    mn:[]
                },
                dimension:"device",
                projects:[],
                devices:[],
                factors:[
                    {  name:"昼数据",key:"dayComplianceRate" },
                    {  name:"夜数据",key:"nightComplianceRate" },
                ],
                dataList:[],
                listLoading:false,
                formHeight:0,

                functionalAreaList:[],
                timeType:"date",
                chooseFac:"",
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            }
        },
        methods: {
            changeType(){
                if(this.filters.datatype=="hour"){
                    this.timeType="datetime";
                }else if(this.filters.datatype=="day"){
                    this.timeType="date";
                }else if(this.filters.datatype=="month"){
                    this.timeType="month";
                }else if(this.filters.datatype=="year"){
                    this.timeType="year";
                }else if(this.filters.datatype=="quarter"){
                    this.timeType="year";
                }else if(this.filters.datatype=="choose"){
                    var data=new Date();
                    data.setTime(data.setDate(data.getDate()-1));

                    var dataBefore=new Date();
                    dataBefore.setTime(dataBefore.setDate(dataBefore.getDate()-8));
                    this.filters.timeRange=[formatDateDay(dataBefore),formatDateDay(data)];
                }
            },
            //获取选中设备可监测的因子
            getFactorsByMn(){
                if(this.filters.mn.toString()==""){
                    return;
                }
                if(in_array('-2',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                if(in_array('-1',this.filters.mn)){
                    this.filters.mn=[];
                    this.devices.forEach(element => {
                        this.filters.mn.push(element.mnCode);
                    });
                }
            },
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="reset"){
					this.reset();
				}else if(type=="export"){
					this.exportData();
				}
			},
            exportData(){
                require.ensure([], () => {
                    const { export_json_to_excel } = require('vendor/Export2Excel');
                    var tHeader =  [];
                    var filterVal = [];  
                    if(this.chooseDimension=="device"){
                        tHeader =  [ '序号','项目名称','功能区名称', '点位名称', '昼达标率（%）', '夜达标率（%）' ];
                        filterVal = ['index','projectName', 'functionalAreaName', 'deviceName','dayComplianceRate','nightComplianceRate' ];  
                    }else if(this.chooseDimension=="project"){
                        tHeader =  [ '序号','项目名称', '昼达标率（%）', '夜达标率（%）' ];
                        filterVal = ['index','projectName' ,'dayComplianceRate','nightComplianceRate'  ];  
                    }else{
                        tHeader =  [ '序号', '功能区名称','昼达标率（%）', '夜达标率（%）' ];
                        filterVal = ['index','functionalAreaName' ,'dayComplianceRate','nightComplianceRate'  ];  
                    }

                    var data=[];
                    var sheetName=[];
                    data.push(this.formatJson(filterVal, this.dataList));
                    sheetName.push('Sheet1');

                    export_json_to_excel(tHeader, data, '达标率数据',sheetName);
                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
            reset(){
                this.filters.projectId=[];
                this.filters.functionalArea="";
                this.filters.dataType="day";
                this.timeType="date";
                var data=new Date();
                data.setTime(data.setDate(data.getDate()-1));
                this.filters.time=formatDateDay(data);
                this.factors=this.dayfactors;
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                   this.projects = res.data.data;
                    this.listLoading = false;
                    
			        if(this.projects.length>0){
                        this.filters.projectId=[];
                        this.filters.projectId.push(this.projects[0].projectId);
						this.getDataList();
                        this.getDevices();
					}
				});
			},
            //获取设备列表
			getDevices() {
                if(this.dimension=="project"){
                    return;
                }
                if( this.filters.projectId.toString()==""){
                    return;
                }
                let para = {
					projectId: this.filters.projectId.toString()
                };
			getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
				});
            },
            getFunctionalAreaList(){
                getFunctionalAreaList({}).then((res) => {
                    this.functionalAreaList=res.data.data;
				});
			},
            //获取趋势分析数据
            getDataList(){
                if(this.filters.projectId.toString()==""){
                    this.$message({
						message: "项目不能为空",
						type: 'error'
					})
					return;
                } 
                //处理时间
                var startDate="";
                var endDate="";
                if(this.filters.datatype=="choose"){
                    startDate=this.filters.timeRange[0];
                    endDate=this.filters.timeRange[1];
                }
                else if(this.filters.datatype=="day"){
                    startDate=this.filters.time;
                    endDate=this.filters.time;
                }
                else if(this.filters.datatype=="month"){

                    var data=new Date(this.filters.time);
                    data.setDate(1);
                    startDate=formatDateDay(data);
                    
                    data.setTime(data.setMonth(data.getMonth()+1));
                    data.setTime(data.setDate(data.getDate()-1));
                    endDate=formatDateDay(data);
                }
                else if(this.filters.datatype=="quarter"){
                    var year= this.filters.time.split("-")[0];
                    var month=3*this.filters.quarter-2;

                    var data=new Date(year+"-"+month+"-01");
                    startDate=formatDateDay(data);

                    data.setTime(data.setMonth(data.getMonth()+3));
                    data.setTime(data.setDate(data.getDate()-1));
                    endDate=formatDateDay(data);
                }
                else if(this.filters.datatype=="year"){
                    var year= this.filters.time.split("-")[0];
                    startDate=year+"-01-01";
                    endDate=year+"-12-31";
                }
                let para = {
                    projectIdStr:this.filters.projectId.toString(),
                    functionalAreaId:this.filters.functionalArea,
                    dataType:this.filters.datatype,
                    dimension:this.dimension,
                    factory: this.filters.facKeyword,
                    startDate:  startDate,
                    endDate:endDate,
                };
                if(this.dimension!="project"){
                    para.mns=this.filters.mn.toString();
                }

                this.listLoading = true;
                
				selectNoiseDataForRank(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result=="true"){
                        this.chooseFac=this.filters.facKeyword;
                        this.chooseDimension=this.dimension;
                        this.dataList = res.data.datas;
                        for(var i=0;i<this.dataList.length;i++){
                            this.dataList[i].index=(i+1);
                        }
                    } else{
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
                    }
				});
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
            },10)

            var data=new Date();
            data.setTime(data.setDate(data.getDate()-1));
            this.filters.time=formatDateDay(data);

            this.getProjects();
            this.getFunctionalAreaList();
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// OrderRateCalc.vue?63d1e64a